<template>
  <!-- 联系商家弹框 -->
  <el-dialog
    class="contractDialog"
    title=""
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="480px"
  >
    <div class="contentInfos">
      <div class="title">联系商家</div>
      <div class="phoneInfo">
        {{ phone }}
        <!-- <p class="name">联系方式</p>
        <div class="phoneWrap">
          <span class="reslut"> {{ phone }}</span> <span class="lines">|</span>
          <span
            v-clipboard:copy="phone"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            class="copyInfo"
          >复制</span>
        </div> -->
      </div>
      <div class="actionWrap">
        <span class="savebtn" @click="dialogVisible=false">确认</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  filters: {
    phoneSpace(str) {
      if (str) {
        var enStr = String(str).replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
        return enStr
      }
      return str
    }
  },
  data() {
    return {
      dialogVisible: false,
      phone: null
    }
  },
  methods: {
    openDialog(phones) {
      this.phone = phones
      this.dialogVisible = true
    },
    onCopy(e) {
      this.$message('你复制了：' + e.text)
    },
    onError() {}

  }
}
</script>
  <style lang="scss" scoped>
  .contractDialog{
      /deep/.el-dialog{
        background: #424556!important;
        border-radius: 8px 8px 8px 8px;
      }
      /deep/.el-dialog__header{
         display: none;
      }
      /deep/.el-dialog__body{
        padding:40px;
      }
      .title{
        font-size: 24px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
      }
      .phoneInfo{
        margin-top:20px;
        // height: 45px;
        background: #292C3A;
        border-radius: 4px 4px 4px 4px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        padding:10px;
        text-align: center;
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #FFFFFF;
        .name{
            font-size: 18px;
            font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
            font-weight: bold;
            color: #FFFFFF;
        }
        .phoneWrap{
            display: flex;
            align-items: center;
        }
        .lines{
            color:#686868;
        }
        .reslut{
            display: inline-block;
            font-size: 20px;
            font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
            font-weight: normal;
            color: #FFFFFF;
            margin-right:8px;
        }
        .copyInfo{
            display: inline-block;
            margin-left:8px;
            font-size: 16px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #E4CA91;
            cursor: pointer;
        }
      }
      .actionWrap{
        width: 95px;
        margin:40px auto 0;
      }
      .savebtn{
        width:100%;
        display: inline-block;
        height: 40px;
        background: #E4CA91;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: PingFang HK-Medium, PingFang HK;
        font-weight: 500;
        color: #5E4207;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
  }
  </style>

